import baseTheme from "@rongyi.io/gatsby-theme-cara/src/gatsby-plugin-theme-ui"
import { merge } from "theme-ui"

// merge will deeply merge custom values with the
// unknown theme's defaults
export default merge(baseTheme, {
  initialColorModeName: `light`,
})